import { ToastrService } from 'ngx-toastr';
import { HostService } from 'src/app/services/host.service';
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/app.service";
import { UserServiceService } from "src/app/services/user-service.service";
import { LoginserviceService } from "src/app/services/loginservice.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ConstatService } from "src/app/services/constat.service";
import { ShowContratComponent, ShowFileConstatComponent } from '../addconstat/addconstat.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: "app-showconstat",
  templateUrl: "./showconstat.component.html",
  styleUrls: ["./showconstat.component.scss"],
})
export class ShowconstatComponent implements OnInit {
  public userIn: any;
  public code: any;

  panelOpenState:boolean=false;
  responseDetailConstat: any;
  approbation:string;

  constructor(
    public appService: AppService,
    public appServices: UserServiceService,
    public loginService: LoginserviceService,
    public router: Router,
    private toastr: ToastrService,
    public constatService: ConstatService,
    private activetedRoute: ActivatedRoute,
    public hostService:HostService,
    public dialog: MatDialog,
  ) {}
  ngOnInit() {
    this.code = this.activetedRoute.snapshot.queryParamMap.get("code");
    
    this.getDetailConstat();
  }

  public getDetailConstat() {
    const storage = localStorage.getItem("facebook_auth");
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }
    if (storage) {
      this.userIn = JSON.parse(storage);
    }    
    let valeur =this.code;

    this.constatService.showOneconstat(valeur).subscribe((data: any) => {
      this.responseDetailConstat = data;
    });
  }

  public getpathImageOfElementConstat(paths:string){
    let arrayPaths= paths.split(';');
    arrayPaths = arrayPaths.filter(elt=>elt!="");
    return arrayPaths;
  }

  public deleteConstat(id:number)
  {
      this.constatService.deleteConstat(id).subscribe((data:any)=>{
        console.log(data);
        this.toastr.success('le constat a été supprimé avec succes ');
        this.router.navigateByUrl('/compte-utilisateur/constat').then();
      },error=>{
        console.log(error);
      })
  }

  public approuverOrRejeter(value:boolean)
  {
    let objectData={
      statut_constat:value?'validé':'refusé',
      id:this.code,
      signature:""
    }
    this.approbation= value?'validé':'refusé';

    if(value==true &&  this.responseDetailConstat.signature_locataire ==null)
    {
      const dialogRef = this.dialog.open(SignatureConstatComponent, {
        width: '780px',
        height:'500px',
        data: {data:this.responseDetailConstat}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        
        objectData.signature=result.signature;
       
        this.constatService.updateConstat(objectData).subscribe((data) => {
          this.toastr.success('Statut mis à jour avec succes.');
          this.router.navigateByUrl('/compte-utilisateur/constat').then();
        },error=>{
          this.toastr.success('Une erreru s\'est produite veillez contacter l\'administrateur système.');
        }); 

      });
    }
    else if((value==true &&  this.responseDetailConstat.signature_locataire !=null) || value==false)
    {
      this.constatService.updateConstat(objectData).subscribe((data) => {
        this.toastr.success('Statut mis à jour avec succes.');
        this.router.navigateByUrl('/compte-utilisateur/constat').then();
      },error=>{
        this.toastr.success('Une erreru s\'est produite veillez contacter l\'administrateur système.');
      }); 
    }   
  }

  seeFile(file:any)
  {
    const dialogRef = this.dialog.open(ShowFileConstatComponent, {
      width: '780px',
      height:'500px',
      data: {file: file} 
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  
  
  downloadPdf(pdfUrl: string) {
    let linkPdf= this.hostService.getHttpsImage()+'Contrat/'+pdfUrl;
    FileSaver.saveAs(linkPdf);
  }
}

@Component({
  selector: 'app-signature-constat',
  templateUrl: 'signature-constat.component.html',
})
export class SignatureConstatComponent implements OnInit {
  imageSrc: string;

  
  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;

  public signaturePadOptions: NgSignaturePadOptions = { // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 500,
    canvasHeight: 300
  };

  constructor(
    public dialogRef: MatDialogRef<SignatureConstatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    //console.log(this.data);
  }
  
  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
    this.effacer(); // invoke functions from szimek/signature_pad API
  }

  effacer()
  {
    this.signaturePad.clear();
  }


  drawComplete(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onEnd event
    
  }

  drawStart(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onBegin event
    
  }
 
  onNoClick(): void {
    this.dialogRef.close();
  }

  saveSignature()
  {
    let obj={
      signature:this.signaturePad.toDataURL(),
    }
    this.dialogRef.close(obj);
  }

  voirContrat(){
   let vehicule = this.data.data.constat.vehicule
   vehicule.user= this.data.data.constat.proprietaire

   let renting = this.data.data.constat.renting
   renting.locataire= this.data.data.constat.locataire

    const dialogRef = this.dialog.open(ShowContratComponent, {
      width: '780px',
      height:'780px',
      data: {vehicule: vehicule,renting:renting},
    });
  }

}